import type { UseQueryResult } from 'react-query';
import { useQuery } from 'react-query';
import { getAllExperiments } from './api';
import type { Experiment } from './model/Experiment';

const OPTIMIZELY_QUERY_KEY = 'optimizely';

export const useAllOptimizelyExperiments = (
  siteId?: number,
): UseQueryResult<Experiment[], Error> => {
  return useQuery<Experiment[], Error>(
    `${OPTIMIZELY_QUERY_KEY}-${siteId}`,
    () => getAllExperiments(siteId as number, 'optimizelyExperiment'),
    {
      enabled: false, // We fetch when we open the dropdown
      placeholderData: [],
      refetchOnWindowFocus: false,
    },
  );
};
